import * as R from "ramda"

interface Route {
  path: string
  step?: number
}

/**
 * Single source of truth for the funnel routes — the pages the user navigates
 * to via `router.push(ROUTES.x.path)`. Most carry a breadcrumb `step`; the
 * stepless ones (pet-health sub-flow, payment) are still real push targets.
 */
export const ROUTES = {
  petName: { path: "/quote/petName", step: 1 },
  petInfo: { path: "/quote/petInfo", step: 2 },
  petBreed: { path: "/quote/petBreed", step: 3 },
  petBirthdate: { path: "/quote/petBirthdate", step: 4 },
  tribeQuote: { path: "/quote/tribeQuote", step: 8 },
  tribe: { path: "/quote/tribe", step: 5 },
  attributionQuestion: { path: "/quote/attributionQuestion", step: 6 },
  userMailPhone: { path: "/quote/userMailPhone", step: 7 },
  prepackages: { path: "/quote/prepackages", step: 15 },
  healthCoverage: { path: "/quote/healthCoverage", step: 8 },
  healthCoverageParam: { path: "/quote/healthCoverageParam", step: 8 },
  medicalHistory: { path: "/quote/medicalHistory", step: 8 },
  userInformations: { path: "/quote/userInformations", step: 10 },
  userAddress: { path: "/quote/userAddress", step: 11 },
  userBirthInformations: { path: "/quote/userBirthInformations", step: 12 },
  pricing: { path: "/quote/pricing", step: 13 },
  recap: { path: "/quote/recap", step: 14 },
  petHealth: { path: "/quote/petHealth" },
  petOldDiseases: { path: "/quote/petOldDiseases" },
  payment: { path: "/quote/payment" },
} as const satisfies Record<string, Route>

/**
 * Path prefixes used only for "which area am I in?" checks
 * (`pathname.includes(...)` / `startsWith(...)`), never as `router.push` targets.
 * Kept separate from `ROUTES` because they are not single navigable destinations.
 */
export const ROUTE_PREFIXES = {
  redirect: "/redirect",
  landingPage: "/redirect/landing-page",
  welcome: "/welcome",
  pet: "/quote/pet",
  user: "/quote/user"
} as const

export const ROUTES_ARRAY = R.values(ROUTES)

export function getStepNumber(pathname: string) {
  const currentRoute = R.find(
    (route: Route) => route.step !== undefined && pathname.includes(route.path)
  )(ROUTES_ARRAY)
  return currentRoute?.step || 1
}
